// extracted by mini-css-extract-plugin
export default {"loading":"InformationTable_loading__ihozR","table":"InformationTable_table__r6I6h"};